import * as $               from 'jquery';
import { $body }            from 'Core/Body';
import { Notifications }    from 'Core/Notifications';
import PasswordFields       from "./Fields/PasswordFields";

export const ResetPassword = (() => {

    const Selector = {
        FORM                : '#resetPasswordForm',
        SUBMIT_BUTTON       : '#sendResetPasswordForm'
    };

    $(Selector.FORM).validate({
        ignore: '',
        rules: PasswordFields.getFields(Selector)
    });

    function submitResetPasswordForm() {
        if($(Selector.FORM).valid()) {
            $.post($(Selector.FORM).attr('action'), $(Selector.FORM).serialize(), $result => {
                if($result.status === "success") {
                    $('#api-input').html($result.response);
                }
                else {
                    Notifications.add($result.msg, "error", {lifespan: 10000});
                }
            });
        }
    }

    $body.on('click', Selector.SUBMIT_BUTTON, submitResetPasswordForm);
})();

import * as $               from 'jquery';
import { $body }            from 'Core/Body';
import { Notifications }    from 'Core/Notifications';
import PasswordFields       from "./Fields/PasswordFields";

export const ResetPassword = (() => {

    const Selector = {
        FORM                : '#resetPasswordForm',
        SUBMIT_BUTTON       : '#sendResetPasswordForm'
    };

    $(Selector.FORM).validate({
        ignore: '',
        rules: PasswordFields.getFields(Selector)
    });

    function submitResetPasswordForm() {
        if($(Selector.FORM).valid()) {
            $.post($(Selector.FORM).attr('action'), $(Selector.FORM).serialize(), $result => {
                if($result.status === "success") {
                    $('#api-input').html($result.response);
                }
                else {
                    Notifications.add($result.msg, "error", {lifespan: 10000});
                }
            });
        }
    }

    $body.on('click', Selector.SUBMIT_BUTTON, submitResetPasswordForm);
})();

